import { render, staticRenderFns } from "./ModalCBU.vue?vue&type=template&id=37755306&scoped=true"
import script from "./ModalCBU.vue?vue&type=script&lang=js"
export * from "./ModalCBU.vue?vue&type=script&lang=js"
import style0 from "./ModalCBU.vue?vue&type=style&index=0&id=37755306&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37755306",
  null
  
)

export default component.exports